module.exports = __webpack_public_path__ + "static/media/banner.ff6f6977.png";